import { ref } from 'vue';

const notifications = ref([]);

const addNotify = (message) => {
    notifications.value.push(message);
};

const removeNotify = () => {
    notifications.value.splice(0, notifications.value.length);
};

export function useNotify() {
    return {
        notifications: notifications.value,
        addNotify,
        removeNotify
    };
}
